import "./shortAnswerArea.scss";

export default function ShortAnswerArea(props: {
  title?: string;
  answers?: string[];
}) {
  return (
    <div className="short-answer-container">
      <h3 style={{ margin: "0.5rem", alignSelf: "flex-start" }}>
        {props.title}
      </h3>
      <hr style={{ width: "100%" }} />
      {props.answers?.map((e, i) => (
        <p key={i} style={{ fontSize: "14px", margin: "0.5rem" }}>
          {e}
        </p>
      ))}
    </div>
  );
}
